import { KeyInfoLinkField } from '@dap/sanity/types';
import { Stack, Typography, useTheme } from '@mui/material';
import InlineExternalLink from '../InlineExternalLink';

interface Props {
  value: Omit<KeyInfoLinkField, '_type'>;
}

export default function KeyInfoLink(props: Props) {
  const { breakpoints } = useTheme();
  const { url, title } = props.value;

  const href = url.startsWith('https://') || url.startsWith('http://') ? url : `https://${url}`;

  return (
    <Stack>
      <Typography variant="h6" component="h3">
        {title}
      </Typography>
      <InlineExternalLink
        variant="body2"
        href={href}
        noWrap
        sx={{
          [breakpoints.down('md')]: {
            maxWidth: 'calc(100vw - 64px)',
          },
        }}
      >
        {href}
      </InlineExternalLink>
    </Stack>
  );
}
